export default {
  create(payload) {
    return axios.post('/catalogs', payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  list(page = 1) {
    return axios.get(`/catalogs?page=${page}`)
  },
  update(id, payload) {
    payload.append('_method', 'PUT');

    return axios.post(`/catalogs/${id}`, payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  delete(id) {
    return axios.delete(`/catalogs/${id}`);
  },
  getLayouts(id, page = 1, sort = 'id_asc') {
    return axios.get(`/catalogs/${id}/layouts?page=${page}&sort=${sort}`)
  },
  updateProofs(catalogID, payload) {
    return axios.post(`/catalogs/${catalogID}/update-proofs`, payload)
  },
  unpinLayoutFromCatalog(catalogID, layoutID) {
    return axios.delete(`/catalogs/${catalogID}/layouts/${layoutID}`);
  },
  getViewData(slug, layouts = []) {
    return axios.get(`/catalogs/${slug}/view-data`, {
      params: {
        layouts: JSON.stringify(layouts),
      },
    });
  },
}
